const QUICK_FILTER_DIACRITICS_REGEX = /[\u0300-\u036f]/g
const QUICK_FILTER_WHITESPACE_REGEX = /\s+/g
const NORMALIZED_QUICK_FILTER_CACHE_LIMIT = 5000

export const normalizeQuickFilterText = (value: string): string =>
  value
    .normalize('NFD')
    .replace(QUICK_FILTER_DIACRITICS_REGEX, '')
    .replace(QUICK_FILTER_WHITESPACE_REGEX, ' ')
    .trim()
    .toUpperCase()

export const buildQuickFilterParts = (quickFilter: string): string[] => {
  const normalizedFilter = normalizeQuickFilterText(quickFilter)
  return normalizedFilter.length > 0 ? normalizedFilter.split(' ') : []
}

const getCachedNormalizedQuickFilterText = (
  value: string,
  cache?: Map<string, string>,
) => {
  if (!cache) return normalizeQuickFilterText(value)

  const cached = cache.get(value)
  if (cached !== undefined) return cached

  const normalized = normalizeQuickFilterText(value)
  if (cache.size >= NORMALIZED_QUICK_FILTER_CACHE_LIMIT) {
    cache.clear()
  }
  cache.set(value, normalized)
  return normalized
}

export const matchesQuickFilterParts = (
  quickFilterParts: string[],
  rowQuickFilterAggregateText: string,
  cache?: Map<string, string>,
) => {
  const normalizedAggregateText = getCachedNormalizedQuickFilterText(
    rowQuickFilterAggregateText,
    cache,
  )

  return quickFilterParts.every((part) => {
    const normalizedPart = normalizeQuickFilterText(part)
    return (
      normalizedPart.length === 0 ||
      normalizedAggregateText.includes(normalizedPart)
    )
  })
}
